<section class="myclasssection">
  <div class="maindiv">
    <div class="container">
      <p class="Real-Time-Gold text-center">Real-Time Gold and Silver Live Prices</p>
      <div class="row">
        <div class="col-md-4 first-borders-box">
          <div class="firstbox" >
            <p class="spot-gold spot-gold-bg">SPOT GOLD</p>
            <p class="price-money" [style.color]="spotGoldColor">
              ${{ spotGold | number: '1.2-2'}}
            </p>
          </div>
        </div>
        <div class="col-md-4 second-borders-box">
          <div class="firstbox" >
            <p class="spot-gold spot-silver-bg">SPOT SILVER</p>
            <p class="price-money-one" [style.color]="spotSilverColor">
              ${{ spotSilver | number: '1.2-2'}}
            </p>
          </div>
        </div>
        <div class="col-md-4 third-borders-box">
          <div class="firstbox" >
            <p class="spot-gold spot-rupee-bg">SPOT RUPEE</p>
            <p class="price-money-two" [style.color]="spotINRColor">
              ₹{{ spotINR | number: '1.2-2'}}
            </p>
          </div>
        </div>
      </div>
    </div>

    <section class="commodiates-section">
      <div class="container">
        <p class="date-time-commed">{{ now | customDateTime }}</p>
        <p class="commedies-paragraph text-center" >Commodities on {{ companyname }}</p>
        <div class="row">

          <!-- GOLD SECTION -->
          <div class="col-md-6">
            <div class="box">
              <div class="justify-content-center">
                <p class="spot-gold live-gold-bg">GOLD</p>
                <div class="gold-live-main gold">
                  <div class="price-with-hl">
                    <div class="hl-left">
                      <p class="gold-live">Live Price Per Gram 999</p>
                      <h6 *ngIf="!socketSubscription || !livePriceSubscription; else liveGoldRate"
                        [style.color]="spotGoldColor" class="spot-para">
                        ₹ {{ spotGoldUpdate }}
                      </h6>
                      <ng-template #liveGoldRate>
                        <h6 [style.color]="spotGoldColor" class="spot-para">₹ {{ spotGoldUpdate }}</h6>
                      </ng-template>
                    </div>
                    <div class="hl-badges">
                      <span class="hl-badge high-badge">H {{ goldDayHigh | number:'1.0-0' }}</span>
                      <span class="hl-badge low-badge">L {{ goldDayLow | number:'1.0-0' }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="shouldShowAlert && treding" class="alert-message timingsAlert">
                Trading is closed for now. You can Trade between Monday-Friday 9:30 AM - 11:30 PM.
              </div>
              <div *ngIf="isLogin && isWeekendDay" class="text-danger">
                Trading is closed for today. You can Trade between Monday-Friday 9:30 AM - 11:30 PM.
              </div>

              <div class="d-flex justify-content-center" *ngIf="isLogin && treding">
                <button [style.background]="backGroundColor?.cardBackGroundColor" class="book-gold-btn"
                  *ngIf="kyc_status == 2" (click)="callLimit('Gold')" data-bs-toggle="modal"
                  data-bs-target="#bookGoldModal">Book Gold</button>
                <button [style.background]="backGroundColor?.cardBackGroundColor" class="book-gold-btn"
                  *ngIf="kyc_status == 0" type="button" data-bs-toggle="modal" data-bs-target="#updateKyx">Book Gold</button>
                <button [style.background]="backGroundColor?.cardBackGroundColor" class="book-gold-btn"
                  *ngIf="kyc_status == 1" type="button" data-bs-toggle="modal" data-bs-target="#Kyxpending">Book Gold</button>
                <button [style.background]="backGroundColor?.cardBackGroundColor" class="book-gold-btn"
                  *ngIf="kyc_status == 3" type="button" data-bs-toggle="modal" data-bs-target="#Kyxrejected">Book Gold</button>

                <!-- Buy Gold -> now opens the "What would you like to buy?" (Coins / Bars) picker -->
                <button [style.background]="backGroundColor?.cardBackGroundColor" class="buy-gold-btn"
                  *ngIf="kyc_status == 2" (click)="callLimit('Gold')" data-bs-toggle="modal"
                  data-bs-target="#buyGoldModalNew">Buy Gold</button>
                <button [style.background]="backGroundColor?.cardBackGroundColor" class="buy-gold-btn"
                  *ngIf="kyc_status == 0" type="button" data-bs-toggle="modal" data-bs-target="#updateKyx">Buy Gold</button>
                <button [style.background]="backGroundColor?.cardBackGroundColor" class="buy-gold-btn"
                  *ngIf="kyc_status == 1" type="button" data-bs-toggle="modal" data-bs-target="#Kyxpending">Buy Gold</button>
                <button [style.background]="backGroundColor?.cardBackGroundColor" class="buy-gold-btn"
                  *ngIf="kyc_status == 3" type="button" data-bs-toggle="modal" data-bs-target="#Kyxrejected">Buy Gold</button>
              </div>
            </div>
          </div>

          <!-- SILVER SECTION -->
          <div class="col-md-6">
            <div class="box">
              <div class="justify-content-center">
                <p class="spot-gold live-silver-bg">SILVER</p>
                <div class="gold-live-main silver">
                  <div class="price-with-hl">
                    <div class="hl-left">
                      <p class="gold-live">Live Price Per Kg</p>
                      <h6 *ngIf="!socketSubscription || !livePriceSubscription; else liveSilverRate"
                        [style.color]="spotSilverColor" class="spot-para">
                        ₹ {{ spotSilverUpdate }}
                      </h6>
                      <ng-template #liveSilverRate>
                        <h6 [style.color]="spotSilverColor" class="spot-para">₹ {{ spotSilverUpdate }}</h6>
                      </ng-template>
                    </div>
                    <div class="hl-badges">
                      <span class="hl-badge high-badge">H {{ silverDayHigh | number:'1.0-0' }}</span>
                      <span class="hl-badge low-badge">L {{ silverDayLow | number:'1.0-0' }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="shouldShowAlert && treding" class="alert-message timingsAlert">
                Trading is closed for now. You can Trade between Monday-Friday 9:30 AM - 11:30 PM.
              </div>
              <div *ngIf="isLogin && isWeekendDay" class="text-danger">
                Trading is closed for today. You can Trade between Monday-Friday 9:30 AM - 11:30 PM.
              </div>

              <div class="d-flex justify-content-center" *ngIf="isLogin && treding">
                <button class="buy-silver-btn" *ngIf="kyc_status == 2" (click)="callLimit('Silver')"
                  data-bs-toggle="modal" data-bs-target="#bookSilverModal">Book Silver</button>
                <button class="buy-silver-btn" *ngIf="kyc_status == 0" type="button" data-bs-toggle="modal"
                  data-bs-target="#updateKyx">Book Silver</button>
                <button class="buy-silver-btn" *ngIf="kyc_status == 1" type="button" data-bs-toggle="modal"
                  data-bs-target="#Kyxpending">Book Silver</button>
                <button class="buy-silver-btn" *ngIf="kyc_status == 3" type="button" data-bs-toggle="modal"
                  data-bs-target="#Kyxrejected">Book Silver</button>

                <!-- Buy Silver -> now opens the "What would you like to buy?" (Coins / Bars) picker -->
                <button class="buy-silver-btn" *ngIf="kyc_status == 2" (click)="callLimit('Silver')"
                  data-bs-toggle="modal" data-bs-target="#buyGoldModalNewSilver">Buy Silver</button>
                <button class="buy-silver-btn" *ngIf="kyc_status == 0" type="button" data-bs-toggle="modal"
                  data-bs-target="#updateKyx">Buy Silver</button>
                <button class="buy-silver-btn" *ngIf="kyc_status == 1" type="button" data-bs-toggle="modal"
                  data-bs-target="#Kyxpending">Buy Silver</button>
                <button class="buy-silver-btn" *ngIf="kyc_status == 3" type="button" data-bs-toggle="modal"
                  data-bs-target="#Kyxrejected">Buy Silver</button>
              </div>
            </div>
          </div>

        </div>

        <!-- ═══ TREND CHART SECTION ═══════════════════════════════════════════ -->
        <div class="row mt-3">
          <div class="col-12">
            <div class="trend-card" [style.background]="backGroundColor?.cardBackGroundColor">

              <!-- Header layout -->
              <div class="trend-header">

                <!-- Left: title + dropdown stacked -->
                <div class="trend-header-left">
                  <span class="trend-title">Gold vs Silver Trend</span>
                  <select [(ngModel)]="selectedTimeframe" (change)="onTimeframeChange()" class="timeframe-dropdown">
                    <option value="today">Today</option>
                    <option value="week">This Week</option>
                    <option value="month">This Month</option>
                  </select>
                </div>

                <!-- Right: Gold badge, then Silver badge — stacked vertically -->
                <div class="trend-legend">
                  <!-- Gold -->
                  <span class="legend-item">
                    <span class="legend-dot gold-dot"></span>
                    <span class="legend-label">Gold</span>
                    <span class="trend-change positive" *ngIf="goldChangePercent >= 0">
                      ▲ +{{ goldChangePercent | number:'1.2-2' }}%
                    </span>
                    <span class="trend-change negative" *ngIf="goldChangePercent < 0">
                      ▼ {{ goldChangePercent | number:'1.2-2' }}%
                    </span>
                  </span>
                  <!-- Silver -->
                  <span class="legend-item">
                    <span class="legend-dot silver-dot"></span>
                    <span class="legend-label">Silver</span>
                    <span class="trend-change positive" *ngIf="silverChangePercent >= 0">
                      ▲ +{{ silverChangePercent | number:'1.2-2' }}%
                    </span>
                    <span class="trend-change negative" *ngIf="silverChangePercent < 0">
                      ▼ {{ silverChangePercent | number:'1.2-2' }}%
                    </span>
                  </span>
                </div>

              </div><!-- /trend-header -->

              <!-- Chart container -->
              <div class="chart-container" >
                <canvas id="trendChart"></canvas>
              </div>

            </div>
          </div>
        </div>
        <!-- ═══════════════════════════════════════════════════════════════════ -->

      </div>
    </section>
  </div>
</section>

<!-- KYC MODALS -->
<div class="modal fade" id="updateKyx" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title fs-5" id="staticBackdropLabel">KYC Required</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <a class="btn btn-secondary" routerLink="/update-kyc" data-bs-dismiss="modal">Click Here</a>
        <p> to complete your KYC</p>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="Kyxpending" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title fs-5" id="staticBackdropLabel">KYC Pending</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <p>Awaiting KYC approval.</p>
        <p>Please contact us for further assistance!</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="Kyxrejected" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title fs-5" id="staticBackdropLabel">KYC Rejected</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <p>Your KYC has been rejected</p>
        <p>To update</p>
        <a class="btn btn-secondary" routerLink="/update-kyc" data-bs-dismiss="modal">Click Here</a>
      </div>
    </div>
  </div>
</div>

<!-- ============================================
     GOLD "WHAT WOULD YOU LIKE TO BUY?" PICKER (Coins / Bars)
============================================ -->
<div class="modal fade" id="buyGoldModalNew" tabindex="-1" aria-labelledby="buyGoldModalLabel" aria-hidden="true">
  <div class="modal-dialog new-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="buyGoldModalLabel" style="color:black">What would you like to buy?</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <div class="buy-options-wrapper">

          <!-- Gold Coins Option -->
          <div class="buy-option-card"
               [class.selected]="selectedOption === 'coins'"
               (click)="selectOption('coins', 'Gold')">
            <div class="option-img-wrap coin-wrap">
              <img src="../../assets/images/Gold-coin.png" alt="Gold Coins" class="option-img" />
            </div>
            <h6 class="option-title">Gold Coins</h6>
            <p class="option-subtitle">Mix coin sizes,<br>min 100g</p>
          </div>

          <!-- Gold Bars Option -->
          <div class="buy-option-card" [class.selected]="selectedOption === 'bars'" (click)="switchToBuyGoldModal()">
            <div class="option-img-wrap bar-wrap">
              <img src="../../assets/images/bars.png" alt="Gold Bars" class="option-img" />
            </div>
            <h6 class="option-title">Gold Bars</h6>
            <p class="option-subtitle">One solid bar,<br>pick a weight</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- ============================================
     SILVER "WHAT WOULD YOU LIKE TO BUY?" PICKER (Coins / Bars)
============================================ -->
<div class="modal fade" id="buyGoldModalNewSilver" tabindex="-1" aria-labelledby="buyGoldModalLabel" aria-hidden="true">
  <div class="modal-dialog new-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="buyGoldModalLabel" style="color:black">What would you like to buy?</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <div class="buy-options-wrapper">

          <!-- Silver Coins Option -->
          <div class="buy-option-card"
               [class.selected]="selectedOption === 'coins'"
               (click)="selectOption('coins', 'Silver')">
            <div class="option-img-wrap coin-wrap">
              <img src="../../assets/images/silvercoin.png" alt="Silver Coins" class="option-img" />
            </div>
            <h6 class="option-title">Silver Coins</h6>
            <p class="option-subtitle">Mix coin sizes,<br>min 100g</p>
          </div>

          <!-- Silver Bars Option -->
          <div class="buy-option-card" [class.selected]="selectedOption === 'bars'" (click)="switchToBuyGoldModalsilver()">
            <div class="option-img-wrap bar-wrap">
              <img src="../../assets/images/silvernewbar.png" alt="Silver Bars" class="option-img" />
            </div>
            <h6 class="option-title">Silver Bars</h6>
            <p class="option-subtitle">One solid bar,<br>pick a weight</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- BOOK GOLD MODAL -->
<div class="modal fade" id="bookGoldModal" tabindex="-1" aria-labelledby="bookGoldModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="bookGoldModalLabel">Book Gold</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="bookGoldForm" (ngSubmit)="onGoldSubmit('gold')">
          <div class="pop-up-gold">
            <img src="../../assets/goldone.png" alt="" />
            <h6 class="heading-price-gram">Gold Live Price Per Gram</h6>
            <h4 class="price-popup-counter">₹ {{ stayBuyGoldRate }}</h4>
          </div>
          <p style="color:red;font-weight:600;text-align:left;">Price will be locked for: {{ timerBuy }} seconds</p>
          <select class="formselect-gold" formControlName="quantity_purchased">
            <option value="" disabled>Quantity</option>
            <option *ngFor="let limit of goldMaxLimit" [value]="limit">{{limit}} Grams</option>
          </select>
          <div class="validationError"
            *ngIf="bookGoldForm.get('quantity_purchased')?.hasError('required') && bookGoldForm.get('quantity_purchased')?.touched">
            Quantity is required.
          </div>
          <br /><br />
          <p class="fixAmount">
            The maximum range for placing buy orders should be within a difference of <b>₹110</b> from the live gold price.
          </p>
          <input type="text" formControlName="book_rate"
            (input)="userAmount(bookGoldForm.get('book_rate')?.value)"
            class="formselect-gold" placeholder="Enter your amount" />
          <div class="validationError"
            *ngIf="bookGoldForm.get('book_rate')?.hasError('required') && bookGoldForm.get('book_rate')?.touched">
            Amount is required.
          </div>
          <div class="validationError"
            *ngIf="bookGoldForm.get('book_rate')?.hasError('pattern') && bookGoldForm.get('book_rate')?.touched">
            Please enter a valid amount.
          </div>
          <button class="buy-gold-popup" *ngIf="bookGoldForm.invalid" [disabled]="true" type="button">Book</button>
          <button class="buy-gold-popup-valid" *ngIf="bookGoldForm.valid && isAmountLessThan110" type="submit"
            data-bs-dismiss="modal">Book</button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- BUY GOLD MODAL (direct - Bars flow lands here) -->
<div class="modal fade" id="buyGoldModal" tabindex="-1" aria-labelledby="buyGoldModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="buyGoldModalLabel">Buy Gold</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="buyGoldForm" (ngSubmit)="onBuySubmit('Gold')">
          <div class="pop-up-gold">
            <img src="../../assets/goldone.png" alt="" />
            <h3 class="heading-price-gram">Gold Live Price Per Gram</h3>
            <h4 class="price-popup-counter">{{ stayBuyGoldRate | currency: "INR":"symbol":"1.0-2" }}</h4>
          </div>
          <p style="color:red;font-weight:600;text-align:left;">Price will be locked for: {{ timerBuy }} seconds</p>
          <select class="formselect-gold" formControlName="quantity_purchased">
            <option value="" disabled>Quantity</option>
            <option *ngFor="let limit of goldMaxLimit" [value]="limit">{{limit}} Grams</option>
          </select>
          <div class="validationError"
            *ngIf="buyGoldForm.get('quantity_purchased')?.hasError('required') && buyGoldForm.get('quantity_purchased')?.touched">
            Quantity is required.
          </div>
          <button class="buy-gold-popup" *ngIf="buyGoldForm.invalid" [disabled]="true" type="button">Buy</button>
          <button class="buy-gold-popup-valid" *ngIf="buyGoldForm.valid" type="submit" data-bs-dismiss="modal">Buy</button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- BOOK SILVER MODAL -->
<div class="modal fade" id="bookSilverModal" tabindex="-1" aria-labelledby="bookSilverModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="bookSilverModalLabel">Book Silver</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="bookSilverForm" (ngSubmit)="onGoldSubmit('silver')">
          <div class="pop-up-gold">
            <img src="../../assets/Silverone.png" alt="" />
            <h6 class="heading-price-gram">Silver Live Price Per 1kg</h6>
            <h4 class="price-popup-counter-second">{{ stayBuySilverRate | currency: "INR":"symbol":"1.0-2" }}</h4>
          </div>
          <p style="color:red;font-weight:600;text-align:left;">Price will be locked for: {{ timerBuy }} seconds</p>
          <select class="formselect-gold" formControlName="quantity_purchased">
            <option value="" disabled>Quantity</option>
            <option *ngFor="let limit of silverMaxLimit" [value]="limit">{{limit}} Grams</option>
          </select>
          <div class="validationError"
            *ngIf="bookSilverForm.get('quantity_purchased')?.hasError('required') && bookSilverForm.get('quantity_purchased')?.touched">
            Quantity is required.
          </div>
          <br /><br />
          <p class="fixAmount">
            The maximum range for placing buy orders should be within a difference of <b>₹1000</b> from the live silver price.
          </p>
          <input type="text" formControlName="book_rate"
            (input)="userAmountSilver(bookSilverForm.get('book_rate')?.value)"
            class="formselect-gold" placeholder="Enter your amount" />
          <div class="validationError"
            *ngIf="bookSilverForm.get('book_rate')?.hasError('required') && bookSilverForm.get('book_rate')?.touched">
            Amount is required.
          </div>
          <div class="validationError"
            *ngIf="bookSilverForm.get('book_rate')?.hasError('pattern') && bookSilverForm.get('book_rate')?.touched">
            Please enter a valid amount.
          </div>
          <button class="buy-gold-popup" *ngIf="bookSilverForm.invalid" [disabled]="true" type="button">Book</button>
          <button class="buy-gold-popup-valid" *ngIf="bookSilverForm.valid && isAmountLessThan1000" type="submit"
            data-bs-dismiss="modal">Book</button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- BUY SILVER MODAL (direct - Bars flow lands here) -->
<div class="modal fade" id="buySilverModal" tabindex="-1" aria-labelledby="buySilverModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="buySilverModalLabel">Buy Silver</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="buySilverForm" (ngSubmit)="onBuySubmit('Silver')">
          <div class="pop-up-gold">
            <img src="../../assets/Silverone.png" alt="" />
            <h6 class="heading-price-gram">Silver Live Price Per 1kg</h6>
            <h4 class="price-popup-counter-second">{{ stayBuySilverRate | currency: "INR":"symbol":"1.0-2" }}</h4>
          </div>
          <p style="color:red;font-weight:600;text-align:left;">Price will be locked for: {{ timerBuy }} seconds</p>
          <select class="formselect-gold" formControlName="quantity_purchased">
            <option value="" disabled>Quantity</option>
            <option *ngFor="let limit of silverMaxLimit" [value]="limit">{{limit}} Grams</option>
          </select>
          <div class="validationError"
            *ngIf="buySilverForm.get('quantity_purchased')?.hasError('required') && buySilverForm.get('quantity_purchased')?.touched">
            Quantity is required.
          </div>
          <button class="buy-gold-popup" *ngIf="buySilverForm.invalid" [disabled]="true" type="button">Buy</button>
          <button class="buy-gold-popup-valid" *ngIf="buySilverForm.valid" type="submit" data-bs-dismiss="modal">Buy</button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- DOWNLOAD SECTION -->
<section class="download-section">
  <p class="download-paragraph">Download Our App</p>
  <div class="text-center">
    <img src="../../assets/bhavav.png" class="bhavanimg" alt="" />
  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6 text-center">
        <div><img src="../../assets/Artboardstar.png" alt="" /></div>
        <div>
          <a href="https://play.google.com/store/apps/details?id=com.goldsikka.gbharath&hl=en" target="_blank">
            <img src="../../assets/goldbahratgoogleplay.png" class="googleplay" alt="" />
          </a>
        </div>
        <div>
          <a href="https://apps.apple.com/in/app/goldbharat/id6443963704" target="_blank">
            <img src="../../assets/Goldbaharatappstore.png" class="googleplay" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- LICENCE SECTION -->
<section class="licence-and-certificate">
  <p class="products-paragraph">Licence & Certificate</p>
  <div class="text-center">
    <img src="../../assets/bhavav.png" class="bhavanimg" alt="" />
  </div>
  <div class="container">
    <div class="img">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-2 col-6"><img src="../../assets/licence-1.png" alt=""></div>
        <div class="col-md-2 col-6"><img src="../../assets/licence-2.png" alt=""></div>
        <div class="col-md-2 col-6"><img src="../../assets/licence-3.png" alt=""></div>
        <div class="col-md-2 col-6"><img src="../../assets/licence-4.png" alt=""></div>
        <div class="col-md-2 col-6"><img src="../../assets/licence-5.png" alt=""></div>
        <div class="col-md-1"></div>
      </div>
    </div>
  </div>
</section>

<!-- CONTACT US SECTION -->
<section class="our-products-section">
  <p class="products-paragraph">Contact Us</p>
  <div class="text-center">
    <img src="../../assets/bhavav.png" class="bhavanimg" alt="" />
  </div>
  <div class="container customsection">
    <div class="row">
      <div class="col-md-4 box-col-one">
        <div class="phone-card">
          <p class="contact-number">Contact Number</p>
          <div class="contact-information">
            <span class="contact-span">
              <img src="../../assets/phone.svg" alt="Phone Icon" />
              <p *ngFor="let phone of phoneNumbers; let i = index; let last = last">
                <a class="telecontact">{{ phone }}<span *ngIf="!last"> /</span></a>
              </p>
            </span>
          </div>
          <p class="contact-number">Timings</p>
          <span class="time-span">
            <img src="../../assets/on-time.svg" alt="" />
            <p class="clock-time-para">{{ timings }}</p>
          </span>
        </div>
      </div>
      <div class="col-md-4 box-col-one">
        <div class="phone-card">
          <p class="contact-number">WhatsApp Number</p>
          <div class="contact-information justify-content-start">
            <span class="contact-span">
              <img src="../../assets/whatsapp.svg" alt="" />
              <p><a [href]="getWhatsAppLink(whatsappNumber)" class="telecontact" target="_blank">{{ whatsappNumber }}</a></p>
            </span>
          </div>
          <p class="contact-number">Email ID</p>
          <span class="time-span justify-content-start">
            <img src="../../assets/gmail.svg" alt="" />
            <p><a class="clock-time-para">{{ email }}</a></p>
          </span>
        </div>
      </div>
      <div class="col-md-4 box-col-three">
        <div class="phone-card">
          <span class="home-address-div">
            <p class="contact-number">Address</p>
          </span>
          <p class="gold-limited-para">
            <a>{{ address }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</section>